
// const version = '/v1.0.0';
const Api = {
  // getHomeData: '/powerfilmer/tologin',
  getDispConfig:'/powerfilmer/v1.0/getOrgByCode',
  loginCheck:'/powerfilmer/v1.0/loginCheck',
  getHomeData: '/powerfilmer/v1.0/get',
  getHospitalLogo: '/powerfilmer/v1.0/getOrgByCode',
  getHistoryData:'/powerfilmer/v1.0/getHistoryByPtNo', // 获取历史检查
  getImageAndText:'/powerfilmer/login/report/get', // 获取图文报告
  getElectronicFilmData: '/powerfilmer/login/getPhoto/get', // 电子胶片
  getImageBrowsingData: '/powerfilmer/login/getFilm/get', // 影像浏览
  getImageTiaoChuangData: '/powerfilmer/login/getReportxml', // 影像浏览调窗动态数据
  getQrcodeRule: '/powerfilmer/v1.0/getQrcodeRule', // 获取分享路劲
  qr_codeCreate: '/powerfilmer/v1.0/qr_code/create', // 获取分享路劲
  projectVersion:'/powerfilmer/v1.0/projectVersion', // 版本信息
  aesDecrypt:'/powerfilmer/login/aesDecrypt', // 版本信息
  sendVerification:'/powerfilmer/v1.0/sendVerification', // 版本信息
  getPatientPhone:'/powerfilmer/v1.0/getPatientPhone', // 版本信息
  getDicByFieldName:'/powerfilmer/login/getDicByFieldName', // 版本信息

}
export default Api
